module.exports = __webpack_public_path__ + "static/media/10x8.7e77b322.png";